import { HttpClient } from "./lib/fetchClient";
import { API_URL /*, API_URL_2*/ } from "./config/index";

export const api = new HttpClient(API_URL); //new FetchClient(API_URL);
// export const api2 = new FetchClient(API_URL_2);
